export enum ReBetMyBetsTabs {
    Live = 'LIVE',
    Open = 'OPEN',
    Settled = 'SETTLED',
}
